// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/hero-waveform.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/slider-handle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Accessibility utility classes */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Skip link for keyboard navigation */
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #4a9c6d;
  color: white;
  padding: 8px 16px;
  text-decoration: none;
  z-index: 10000;
  font-weight: bold;
  border-radius: 0 0 4px 0;
}

.skip-link:focus {
  top: 0;
  outline: 3px solid #c9a227;
  outline-offset: 2px;
}

/* Enhanced focus indicators */
*:focus {
  outline: 2px solid #4a9c6d;
  outline-offset: 2px;
}

*:focus:not(:focus-visible) {
  outline: none;
}

*:focus-visible {
  outline: 2px solid #4a9c6d;
  outline-offset: 2px;
}

button:focus-visible,
a:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 2px solid #4a9c6d;
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(74, 156, 109, 0.2);
}

body {
  font-family: 'Instrument Sans', 'Helvetica Neue', -apple-system, BlinkMacSystemFont, sans-serif;
  background-color: #1a1a1a;
  background-image:
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 2px,
      rgba(0, 0, 0, 0.1) 2px,
      rgba(0, 0, 0, 0.1) 4px
    );
  color: #e8e4dc;
  line-height: 1.5;
}

/* App container */
.app-container {
  min-height: 100vh;
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Landing page: full-width flexbox layout with footer at bottom */
.app-container--landing {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 0;
  background: #111;
  background-image: none;
}

.app-container--landing .main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.app-container--landing .landing-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0;
  max-width: 100%;
  gap: 0;
}

/* Header - Pro Audio Rack Style */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(180deg, #2d2d2d 0%, #242424 100%);
  border-radius: 4px;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.3),
    0 2px 8px rgba(0, 0, 0, 0.4);
  border: 1px solid #3a3a3a;
  position: relative;
  z-index: 1100;
}

.header::before {
  content: '';
  position: absolute;
  top: 4px;
  left: 4px;
  right: 4px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(212, 165, 116, 0.3), transparent);
  border-radius: 1px;
}

.app-title {
  font-family: 'Instrument Sans', 'DIN Alternate', 'Helvetica Neue', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #d4a227; /* Enhanced from #c9a227 for better contrast */
  letter-spacing: 2px;
  text-transform: uppercase;
}

.controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* Buttons - Pro Audio Style */
.btn {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  padding: 10px 18px;
  border: 1px solid #4a4a4a;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-primary {
  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);
  color: #fff;
  border-color: #3d8259;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.15),
    0 2px 4px rgba(0, 0, 0, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 3px 6px rgba(0, 0, 0, 0.4);
  transform: none;
}

.btn-secondary {
  background: linear-gradient(180deg, #3a3a3a 0%, #2d2d2d 100%);
  color: #e8e4dc;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 2px 4px rgba(0, 0, 0, 0.3);
}

.btn-secondary:hover {
  background: linear-gradient(180deg, #4a4a4a 0%, #3a3a3a 100%);
  border-color: #5a5a5a;
  transform: none;
}

/* Hidden controls - keep functionality but hide visually */
.hidden-controls {
  position: absolute;
  left: -9999px;
  opacity: 0;
  pointer-events: none;
}

/* Main content */
.main-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Landing page – SEO-friendly semantic layout */
.landing-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 20px 48px;
  gap: 0;
  margin: 0;
}

/* ===== Landing Waveform Banner ===== */
.landing-hero-waveform {
  position: relative;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  height: 200px;
  background: #000 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x center center;
  background-size: auto 100%;
}

/* ===== Landing Gradient Body ===== */
.landing-gradient-body {
  background: linear-gradient(180deg,
    #000000 0%,
    #0a0d0a 15%,
    #0d120e 30%,
    #101510 50%,
    #121812 70%,
    #141a14 100%
  );
  flex: 1;
}

/* ===== Landing Hero Content ===== */
.landing-hero-content {
  text-align: center;
  padding: 12px 24px 12px 24px;
  width: 100%;
}

.landing-hero-title {
  font-family: 'Instrument Sans', 'DIN Alternate', 'Helvetica Neue', sans-serif;
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 700;
  color: #e8e4dc;
  letter-spacing: 0;
  text-transform: none;
  margin-bottom: 16px;
  line-height: 1.25;
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
}

.landing-hero-tagline {
  font-size: 16px;
  color: #999;
  line-height: 1.6;
  margin-bottom: 36px;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
}

.landing-cta-btn {
  display: inline-block;
  padding: 14px 36px;
  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);
  color: #fff;
  border-radius: 30px;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1px solid #3d8259;
  box-shadow: 0 2px 8px rgba(74, 156, 109, 0.2);
}

.landing-cta-btn:hover {
  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);
  box-shadow: 0 4px 20px rgba(74, 156, 109, 0.35);
  transform: translateY(-1px);
}

/* ===== Landing Features Section ===== */
.landing-features-section {
  padding: 48px 48px 80px;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  background: transparent;
}

.landing-features-heading {
  text-align: center;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #e8e4dc;
  margin-bottom: 12px;
}

.landing-features-subhead {
  text-align: center;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 15px;
  color: #888;
  margin: 0 0 40px;
}

.landing-features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}

.landing-feature-card {
  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);
  border-radius: 12px;
  border: 1px solid #2a2a2a;
  padding: 20px;
  transition: border-color 0.2s ease;
}

.landing-feature-card:hover {
  border-color: #3a3a3a;
}

.landing-feature-card-img-wrapper {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
  background: #0a0a0a;
  
}

.landing-feature-card-img-center {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #282828;
  border-radius: 6px;
}

.landing-feature-card-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 6px;
}

.landing-feature-card-title {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #e8e4dc;
  margin-bottom: 8px;
}

.landing-feature-card-desc {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  color: #888;
  line-height: 1.55;
}

.landing-feature-card-link {
  display: inline-block;
  margin-top: 16px;
  color: #4a9c6d;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.landing-feature-card-link:hover {
  color: #5aac7d;
  text-decoration: underline;
}

.landing-feature-card-link:focus-visible {
  outline: 2px solid #5aac7d;
  outline-offset: 3px;
}

.landing-plans-section {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 0 48px 80px;
  text-align: center;
}

.landing-plans-section .plan-comparison {
  margin-bottom: 24px;
}

.landing-plans-cta {
  display: inline-block;
  padding: 14px 36px;
  border: 1px solid #3d8259;
  border-radius: 30px;
  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);
  box-shadow: 0 2px 8px rgba(74, 156, 109, 0.2);
  color: #fff;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 0.2s ease;
}

.landing-plans-cta:hover {
  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);
  box-shadow: 0 4px 20px rgba(74, 156, 109, 0.35);
  transform: translateY(-1px);
}

/* Legacy landing classes (kept for non-landing usage) */
.landing-body {
  color: #c4bfb5;
  line-height: 1.6;
  margin-bottom: 15px;
}

/* ===== Landing page responsive ===== */
@media (max-width: 1024px) {
  .landing-features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .landing-hero-waveform {
    height: 120px;
  }

  .landing-hero-content {
    padding: 24px 20px 16px;
  }

  .landing-hero-title {
    font-size: clamp(22px, 6vw, 28px);
    margin-bottom: 12px;
  }

  .landing-hero-tagline {
    font-size: 15px;
    margin-bottom: 28px;
  }

  .landing-cta-btn {
    padding: 14px 32px;
    font-size: 13px;
  }

  .landing-features-section {
    padding: 32px 20px 48px;
  }

  .landing-plans-section {
    padding: 0 20px 48px;
  }

  .landing-features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .landing-features-heading {
    font-size: 20px;
    margin-bottom: 24px;
  }

  .landing-feature-card-img-center {
    height: 220px;
  }
}

@media (max-width: 480px) {
  .landing-hero-waveform {
    height: 80px;
  }

  .landing-hero-content {
    padding: 20px 16px 16px;
  }

  .landing-hero-title {
    font-size: clamp(20px, 5.5vw, 24px);
  }

  .landing-hero-tagline {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 24px;
  }

  .landing-hero-tagline br {
    display: none;
  }

  .landing-cta-btn {
    padding: 14px 28px;
    font-size: 12px;
    width: 100%;
    max-width: 280px;
    text-align: center;
  }

  .landing-features-section {
    padding: 24px 16px 40px;
  }

  .landing-plans-section {
    padding: 0 16px 40px;
  }

  .landing-features-heading {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .landing-feature-card {
    padding: 16px;
  }

  .landing-feature-card-img-center {
    height: 180px;
  }

  .landing-feature-card-title {
    font-size: 16px;
  }

  .landing-feature-card-desc {
    font-size: 13px;
  }
}

/* ===== About page ===== */
.about-section {
  padding: 48px 48px 80px;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
}

.about-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
}

.about-card {
  padding: 28px;
}

.about-card-title {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #e8e4dc;
  margin-bottom: 12px;
}

.about-card-desc {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 15px;
  color: #999;
  line-height: 1.65;
}

.about-card-desc strong {
  color: #e8e4dc;
  font-weight: 600;
}

.about-card-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
}

.about-card-list li {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 15px;
  color: #999;
  line-height: 1.65;
  padding: 4px 0 4px 20px;
  position: relative;
}

.about-card-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 12px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);
}

.about-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  margin-top: 16px;
}

.about-contact {
  text-align: center;
  padding: 60px 24px 0;
}

.about-contact-text {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 16px;
  color: #999;
  margin-bottom: 28px;
  line-height: 1.6;
}

/* ===== About page responsive ===== */
@media (max-width: 768px) {
  .about-section {
    padding: 32px 20px 48px;
  }

  .about-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .about-card {
    padding: 24px;
  }

  .about-card-title {
    font-size: 17px;
  }

  .about-card-desc,
  .about-card-list li {
    font-size: 14px;
  }

  .about-contact {
    padding: 40px 20px 0;
  }

  .about-contact-text {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .about-section {
    padding: 24px 16px 40px;
  }

  .about-card {
    padding: 20px;
  }

  .about-card-title {
    font-size: 16px;
  }

  .about-card-desc,
  .about-card-list li {
    font-size: 13px;
  }

  .about-contact {
    padding: 32px 16px 0;
  }

  .about-contact-text {
    font-size: 14px;
  }
}

/* ===== Newsletter page ===== */
.newsletter-section {
  padding: 48px 48px 80px;
  width: 100%;
  max-width: 580px;
  margin: 0 auto;
}

.newsletter-card {
  padding: 36px;
}

/* ===== Newsletter page responsive ===== */
@media (max-width: 768px) {
  .newsletter-section {
    padding: 32px 20px 48px;
  }

  .newsletter-card {
    padding: 28px;
  }
}

@media (max-width: 480px) {
  .newsletter-section {
    padding: 24px 16px 40px;
  }

  .newsletter-card {
    padding: 24px;
  }
}

/* ===== Legal pages (Privacy Policy, Terms, Cookie Policy, Data Deletion) ===== */
.legal-content-section {
  padding: 48px 48px 80px;
  width: 100%;
  max-width: 860px;
  margin: 0 auto;
}

.legal-content-card {
  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);
  border-radius: 12px;
  border: 1px solid #2a2a2a;
  padding: 48px 56px;
}

.legal-content-card h2 {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #d4a574;
  margin-top: 40px;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
}

.legal-content-card h2:first-child {
  margin-top: 0;
}

.legal-content-card h3 {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #d4a574;
  margin-top: 28px;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.legal-content-card p {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 15px;
  color: #c4bfb5;
  line-height: 1.7;
  margin-bottom: 16px;
}

.legal-content-card ul {
  list-style: none;
  padding: 0;
  margin: 16px 0;
}

.legal-content-card li {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 15px;
  color: #c4bfb5;
  line-height: 1.7;
  padding: 4px 0 4px 24px;
  position: relative;
}

.legal-content-card li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 13px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #666;
}

.legal-content-card a {
  color: #4a9c6d;
  text-decoration: none;
  transition: color 0.2s ease;
}

.legal-content-card a:hover {
  color: #5aac7d;
  text-decoration: underline;
}

.legal-content-card code {
  background: #0a0a0a;
  padding: 2px 8px;
  border-radius: 3px;
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 13px;
  color: #d4a574;
  border: 1px solid #2a2a2a;
}

.legal-content-card strong {
  font-weight: 600;
  color: #e8e4dc;
}

.legal-last-updated {
  font-style: italic;
  color: #888;
  font-size: 15px;
}

/* ===== Legal pages responsive ===== */
@media (max-width: 768px) {
  .legal-content-section {
    padding: 32px 20px 48px;
  }

  .legal-content-card {
    padding: 32px 28px;
  }

  .legal-content-card h2 {
    font-size: 20px;
    margin-top: 32px;
  }

  .legal-content-card h3 {
    font-size: 17px;
    margin-top: 24px;
  }

  .legal-content-card p,
  .legal-content-card li {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .legal-content-section {
    padding: 24px 16px 40px;
  }

  .legal-content-card {
    padding: 24px 20px;
  }

  .legal-content-card h2 {
    font-size: 18px;
    margin-top: 28px;
  }

  .legal-content-card h3 {
    font-size: 16px;
    margin-top: 20px;
  }

  .legal-content-card p,
  .legal-content-card li {
    font-size: 13px;
  }

  .legal-last-updated {
    font-size: 14px;
  }
}

/* Top row layout */
.top-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  height: 400px;
}

/* Right panel */
.right-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Cards - Pro Audio Style */
.card {
  background: linear-gradient(180deg, #2a2a2a 0%, #222222 100%);
  border-radius: 4px;
  padding: 20px;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.04),
    inset 0 -1px 0 rgba(0, 0, 0, 0.2),
    0 4px 16px rgba(0, 0, 0, 0.4);
  border: 1px solid #3a3a3a;
  display: flex;
  flex-direction: column;
  position: relative;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(212, 165, 116, 0.2), transparent);
}

.card-title {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #d4a227; /* Enhanced from #c9a227 for better contrast */
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

/* EQ Card Header */
.eq-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.eq-card-header .card-title {
  margin-bottom: 0;
}

.eq-controls {
  display: flex;
  gap: 12px;
}

.chart-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-bottom: 8px;
  background: #1a1a1a;
  border-radius: 3px;
  border: 1px solid #2a2a2a;
}

/* Specific card sizing */
.frequency-response-card {
  flex: 0.5;
  min-height: 180px;
}

.spectrogram-card {
  height: 100%;
}

.z-plane-card {
  flex: 1;
  min-height: 180px;
}

.eq-card {
  height: 320px;
}

/* Canvas styling */
#bar-graph {
  background-color: #0a0a0a;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 280px;
  border-radius: 3px;
}

#spectrogram {
  background: #0a0a0a;
  width: 100%;
  height: 100%;
  border-radius: 3px;
}

#z-plane {
  background-color: #0f0f14;
  border: 1px solid #2a2a2a;
  border-radius: 3px;
  width: 100%;
  height: 100%;
}

/* EQ Container */
#eq-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(180deg, #252525 0%, #1a1a1a 100%);
  border-radius: 3px;
  padding: 16px 12px;
  box-shadow:
    inset 0 2px 4px rgba(0, 0, 0, 0.4),
    inset 0 -1px 0 rgba(255, 255, 255, 0.02);
  border: 1px solid #3a3a3a;
}

.eq-bottom-controls {
  margin-top: 12px;
  display: flex;
  justify-content: flex-start;
  padding-left: 10px;
}

.eq-locked-caption {
  margin: 10px 10px 0;
  color: #a09588;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
}

.eq-led-caption {
  margin: 8px 10px 0;
  color: #8a8578;
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
}

/* DBA hardware-style rocker toggle */
.eq-tooltip-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: none;
  background: none;
  user-select: none;
  cursor: pointer;
}

.eq-tooltip-toggle-text {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #706a60;
}

/* Rocker switch housing */
.eq-tooltip-toggle-switch {
  position: relative;
  display: inline-block;
  width: 14px;
  height: 22px;
  border-radius: 2px;
  background: linear-gradient(180deg, #0a0a0a 0%, #151515 50%, #0a0a0a 100%);
  border: 1px solid #2a2a2a;
  box-shadow:
    inset 0 0 3px rgba(0, 0, 0, 0.9),
    0 1px 0 rgba(255, 255, 255, 0.03);
  pointer-events: none;
}

/* Rocker switch actuator - off state (tilted up) */
.eq-tooltip-toggle-switch::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  height: 8px;
  border-radius: 1px;
  background: linear-gradient(180deg, #8a847a 0%, #5a554c 50%, #3a3632 100%);
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
  transition: top 0.08s ease, transform 0.08s ease, background 0.08s ease;
  transform-origin: center bottom;
  transform: perspective(20px) rotateX(8deg);
}

/* On state - rocker tilted down */
.eq-tooltip-toggle-switch.active::before {
  top: 10px;
  transform: perspective(20px) rotateX(-8deg);
  background: linear-gradient(180deg, #a09a90 0%, #706a60 50%, #4a4640 100%);
}

.eq-tooltip-toggle:hover .eq-tooltip-toggle-switch {
  border-color: #3a3a3a;
}

.eq-tooltip-toggle:hover .eq-tooltip-toggle-switch::before {
  background: linear-gradient(180deg, #9a948a 0%, #6a645a 50%, #4a4642 100%);
}

.eq-tooltip-toggle .toggle-hint {
  position: static;
  transform: none;
  font-size: 11px;
  padding: 2px 4px;
  margin-left: 4px;
}

#eq-bands {
  display: grid;
  grid-template-columns: repeat(31, 1fr);
  align-items: flex-end;
  gap: 4px;
  height: 200px;
  padding: 0 10px;
  overflow-x: auto;
}

.eq-band {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

/* Slider Track */
.eq-slider-track {
  width: 12px;
  height: 120px;
  background: linear-gradient(
    to right,
    #2a2a2a 0%,
    #333333 20%,
    #2d2d2d 50%,
    #333333 80%,
    #2a2a2a 100%
  );
  border-radius: 3px;
  position: relative;
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.3),
    inset 0 1px 1px rgba(0, 0, 0, 0.4),
    inset 0 -1px 1px rgba(255, 255, 255, 0.05);
  border: 1px solid #444;
}

/* Center groove in track */
.eq-slider-track::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 2px;
  bottom: 2px;
  width: 3px;
  transform: translateX(-50%);
  background: linear-gradient(to bottom, #1a1a1a 0%, #111111 50%, #0a0a0a 100%);
  border-radius: 1px;
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.9),
    0 0 1px rgba(255, 255, 255, 0.1);
}

/* Keyboard shortcut hint */
.keyboard-hint {
  position: absolute;
  top: -28px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  font-family: monospace;
  white-space: nowrap;
  pointer-events: none;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: fadeInKeyboardHint 0.15s ease-out;
}

.keyboard-hint::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid rgba(0, 0, 0, 0.9);
}

@keyframes fadeInKeyboardHint {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Slider Handle/Button */
.eq-button {
  width: 20px;
  height: 28px;
  border: none;
  border-radius: 1px;
  /* Photorealistic image with fallback */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  /* Fallback styling if image fails to load */
  background-color: #d0d0d0;
  color: #333;
  font-size: 8px;
  font-weight: 700;
  cursor: grab;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 46px; /* Center position */
  left: 50%;
  transform: translateX(-50%);
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.3);
  z-index: 2;
}

/* Fallback styling when image is not available */
.eq-button:not([style*="background-image"]) {
  background: linear-gradient(145deg, #f0f0f0, #d0d0d0);
  border: 1px solid #555;
  border-radius: 6px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.4),
    inset 0 1px 1px rgba(255, 255, 255, 0.8),
    inset 0 -1px 1px rgba(0, 0, 0, 0.1);

  /* Add ridged texture effect for fallback */
  background-image:
    repeating-linear-gradient(90deg,
      transparent 0px,
      transparent 1px,
      rgba(0, 0, 0, 0.1) 1px,
      rgba(0, 0, 0, 0.1) 2px,
      transparent 2px,
      transparent 3px
    ),
    linear-gradient(145deg, #f0f0f0, #d0d0d0);
}

.eq-button:hover {
  /* Keep the photorealistic image */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transform: translateX(-50%) translateY(-1px);
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.4);
  /* Add a subtle brightness filter for hover effect */
  filter: brightness(1.1) contrast(1.05);
}

/* Fallback hover styling */
.eq-button:hover:not([style*="background-image"]) {
  background: linear-gradient(145deg, #f8f8f8, #d8d8d8);
  background-image:
    repeating-linear-gradient(90deg,
      transparent 0px,
      transparent 1px,
      rgba(0, 0, 0, 0.1) 1px,
      rgba(0, 0, 0, 0.1) 2px,
      transparent 2px,
      transparent 3px
    ),
    linear-gradient(145deg, #f8f8f8, #d8d8d8);
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.4),
    inset 0 1px 1px rgba(255, 255, 255, 0.9),
    inset 0 -1px 1px rgba(0, 0, 0, 0.1);
  filter: none;
}

.eq-button.active {
  /* Use the photorealistic image with blue tint */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  color: white;
  cursor: grabbing;
  box-shadow:
    0 1px 3px rgba(0, 122, 255, 0.4);
  /* Apply blue filter to the image */
  filter: hue-rotate(200deg) saturate(1.5) brightness(0.9);
}

/* Fallback active styling */
.eq-button.active:not([style*="background-image"]) {
  background: linear-gradient(145deg, #007aff, #0056cc);
  background-image:
    repeating-linear-gradient(90deg,
      transparent 0px,
      transparent 1px,
      rgba(255, 255, 255, 0.1) 1px,
      rgba(255, 255, 255, 0.1) 2px,
      transparent 2px,
      transparent 3px
    ),
    linear-gradient(145deg, #007aff, #0056cc);
  border: 1px solid #004499;
  border-radius: 6px;
  box-shadow:
    0 1px 3px rgba(0, 122, 255, 0.4),
    inset 0 1px 1px rgba(255, 255, 255, 0.3),
    inset 0 -1px 1px rgba(0, 0, 0, 0.2);
  filter: none;
}

.eq-button.nearest-target {
  /* Use the photorealistic image with orange tint */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  color: white;
  animation: pulse-target 1.5s ease-in-out infinite;
  box-shadow:
    0 1px 3px rgba(255, 149, 0, 0.4);
  /* Apply orange filter to the image */
  filter: hue-rotate(30deg) saturate(1.8) brightness(1.1);
}

/* Fallback nearest-target styling */
.eq-button.nearest-target:not([style*="background-image"]) {
  background: linear-gradient(145deg, #ff9500, #cc7700);
  background-image:
    repeating-linear-gradient(90deg,
      transparent 0px,
      transparent 1px,
      rgba(255, 255, 255, 0.15) 1px,
      rgba(255, 255, 255, 0.15) 2px,
      transparent 2px,
      transparent 3px
    ),
    linear-gradient(145deg, #ff9500, #cc7700);
  border: 1px solid #aa6600;
  border-radius: 6px;
  box-shadow:
    0 1px 3px rgba(255, 149, 0, 0.4),
    inset 0 1px 1px rgba(255, 255, 255, 0.3),
    inset 0 -1px 1px rgba(0, 0, 0, 0.2);
  filter: none;
}

.eq-button.incorrect {
  /* Use the photorealistic image with red tint */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  color: white;
  animation: shake-incorrect 0.3s ease-in-out;
  box-shadow:
    0 1px 3px rgba(255, 59, 48, 0.4);
  /* Apply red filter to the image */
  filter: hue-rotate(340deg) saturate(1.6) brightness(0.8);
}

/* Fallback incorrect styling */
.eq-button.correct {
  /* Use the photorealistic image with green tint */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  color: white;
  animation: shake-incorrect 0.3s ease-in-out;
  box-shadow:
    0 1px 3px rgba(40, 167, 69, 0.4);
  /* Apply green filter to the image */
  filter: hue-rotate(90deg) saturate(1.6) brightness(0.6);
}

.eq-button.incorrect:not([style*="background-image"]) {
  background: linear-gradient(145deg, #ff3b30, #cc2e26);
  background-image:
    repeating-linear-gradient(90deg,
      transparent 0px,
      transparent 1px,
      rgba(255, 255, 255, 0.15) 1px,
      rgba(255, 255, 255, 0.15) 2px,
      transparent 2px,
      transparent 3px
    ),
    linear-gradient(145deg, #ff3b30, #cc2e26);
  border: 1px solid #aa251d;
  border-radius: 6px;
  box-shadow:
    0 1px 3px rgba(255, 59, 48, 0.4),
    inset 0 1px 1px rgba(255, 255, 255, 0.3),
    inset 0 -1px 1px rgba(0, 0, 0, 0.2);
  filter: none;
}

/* Fallback correct styling */
.eq-button.correct:not([style*="background-image"]) {
  background: linear-gradient(145deg, #28a745, #1e7e34);
  background-image:
    repeating-linear-gradient(90deg,
      transparent 0px,
      transparent 1px,
      rgba(255, 255, 255, 0.15) 1px,
      rgba(255, 255, 255, 0.15) 2px,
      transparent 2px,
      transparent 3px
    ),
    linear-gradient(145deg, #28a745, #1e7e34);
  border: 1px solid #1e7e34;
  border-radius: 6px;
  box-shadow:
    0 1px 3px rgba(40, 167, 69, 0.4),
    inset 0 1px 1px rgba(255, 255, 255, 0.3),
    inset 0 -1px 1px rgba(0, 0, 0, 0.2);
  filter: none;
}

.eq-button.disabled,
.eq-button:disabled {
  cursor: not-allowed;
  filter: grayscale(1) brightness(0.6);
  opacity: 0.7;
}

.eq-label.disabled {
  color: #888; /* Enhanced from #777 for better contrast */
}

.eq-led-checkbox:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

@keyframes pulse-target {
  0%, 100% {
    box-shadow: 0 4px 12px rgba(255, 149, 0, 0.3);
  }
  50% {
    box-shadow: 0 4px 20px rgba(255, 149, 0, 0.6);
  }
}

@keyframes shake-incorrect {
  0%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  25% {
    transform: translateX(-50%) translateY(-3px);
  }
  75% {
    transform: translateX(-50%) translateY(3px);
  }
}

.eq-label {
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 9px;
  font-weight: 600;
  color: #a09588; /* Enhanced from #8a8578 for better contrast */
  text-align: center;
  white-space: nowrap;
  letter-spacing: 0.5px;
}

/* LED Checkbox styling */
.eq-led-checkbox {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid #222;
  background: radial-gradient(circle at 30% 30%, #4a4a4a, #2a2a2a);
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.8),
    inset 0 -1px 1px rgba(255, 255, 255, 0.05),
    0 1px 2px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 4px;
}

.eq-led-checkbox:checked {
  background: radial-gradient(circle at 30% 30%, #c9553d, #a84432);
  box-shadow:
    inset 0 1px 2px rgba(255, 255, 255, 0.2),
    inset 0 -1px 1px rgba(0, 0, 0, 0.4),
    0 0 8px rgba(201, 85, 61, 0.5),
    0 0 12px rgba(201, 85, 61, 0.3),
    0 1px 2px rgba(0, 0, 0, 0.6);
  border-color: #c9553d;
}

.eq-led-checkbox:hover {
  border-color: #444;
}

.eq-led-checkbox:checked:hover {
  border-color: #d96550;
  box-shadow:
    inset 0 1px 2px rgba(255, 255, 255, 0.3),
    inset 0 -1px 1px rgba(0, 0, 0, 0.3),
    0 0 10px rgba(201, 85, 61, 0.7),
    0 0 16px rgba(201, 85, 61, 0.4),
    0 1px 2px rgba(0, 0, 0, 0.5);
}

/* Loading state */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 40px;
  text-align: center;
  color: #a09588; /* Enhanced from #8a8578 for better contrast */
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
}

.loading::before {
  content: '';
  width: 40px;
  height: 40px;
  border: 3px solid rgba(212, 165, 116, 0.2);
  border-top-color: #d4a574;
  border-radius: 50%;
  animation: loading-spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes loading-spin {
  to { transform: rotate(360deg); }
}

/* Error state */
.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 40px;
  text-align: center;
  color: #c9553d;
  background: linear-gradient(180deg, #2a2222 0%, #221a1a 100%);
  border-radius: 4px;
  border: 1px solid #4a3333;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
}

/* Responsive design */
@media (max-width: 1200px) {
  .top-row {
    grid-template-columns: 1fr;
    height: auto;
  }

  .right-panel {
    flex-direction: row;
  }

  .frequency-response-card {
    height: 300px;
  }
}

@media (max-width: 768px) {
  .app-container {
    padding: 16px;
  }

  .header {
    padding: 14px 16px;
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .app-title {
    font-size: 16px;
    letter-spacing: 1.5px;
  }

  .controls {
    flex-wrap: wrap;
    justify-content: center;
  }

  .btn {
    padding: 8px 14px;
    font-size: 11px;
  }

  .right-panel {
    flex-direction: column;
  }

  #eq-bands {
    grid-template-columns: repeat(31, minmax(12px, 1fr));
    gap: 2px;
    padding: 0 8px;
    height: 180px;
  }

  .eq-slider-track {
    width: 10px;
    height: 100px;
  }

  .keyboard-hint {
    font-size: 10px;
    padding: 3px 6px;
    top: -24px;
  }

  .eq-button {
    width: 18px;
    height: 24px;
    font-size: 8px;
    top: 38px;
  }
}`, "",{"version":3,"sources":["webpack://./src/client/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,MAAM;EACN,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;;;EAKE,0BAA0B;EAC1B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,+FAA+F;EAC/F,yBAAyB;EACzB;;;;;;;KAOG;EACH,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,MAAM;AACR;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;EAClB;;;gCAG8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,sFAAsF;EACtF,kBAAkB;AACpB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,8CAA8C;EAC9D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,4DAA4D;EAC5D,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,qBAAqB;EACrB;;gCAE8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D;;gCAE8B;EAC9B,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd;;gCAE8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,MAAM;EACN,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,+EAAyE;EACzE,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE;;;;;;;GAOC;EACD,OAAO;AACT;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,6EAA6E;EAC7E,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,mBAAmB;EACnB,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4DAA4D;EAC5D,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,6CAA6C;EAC7C,WAAW;EACX,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,kFAAkF;AAClF;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb;;;iCAG+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,WAAW;EACX,sFAAsF;AACxF;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,8CAA8C;EAC9D,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB;;4CAE0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4DAA4D;EAC5D,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;EAC1E,yBAAyB;EACzB;;qCAEmC;EACnC,oBAAoB;AACtB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0EAA0E;EAC1E;;2CAEyC;EACzC,uEAAuE;EACvE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA,kCAAkC;AAClC;EACE,SAAS;EACT,2CAA2C;EAC3C,0EAA0E;AAC5E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb;;;;;;;GAOC;EACD,kBAAkB;EAClB,kBAAkB;EAClB;;;8CAG4C;EAC5C,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,6EAA6E;EAC7E,kBAAkB;EAClB;;oCAEkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,wCAAwC;EACxC,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,yDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,4CAA4C;EAC5C,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS,EAAE,oBAAoB;EAC/B,SAAS;EACT,2BAA2B;EAC3B;gCAC8B;EAC9B,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,qDAAqD;EACrD,sBAAsB;EACtB,kBAAkB;EAClB;;;uCAGqC;;EAErC,2CAA2C;EAC3C;;;;;;;;;6CAS2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,yDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,4CAA4C;EAC5C;gCAC8B;EAC9B,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA,2BAA2B;AAC3B;EACE,qDAAqD;EACrD;;;;;;;;;6CAS2C;EAC3C;;;uCAGqC;EACrC,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,yDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB;oCACkC;EAClC,mCAAmC;EACnC,wDAAwD;AAC1D;;AAEA,4BAA4B;AAC5B;EACE,qDAAqD;EACrD;;;;;;;;;6CAS2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB;;;uCAGqC;EACrC,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,yDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,iDAAiD;EACjD;oCACkC;EAClC,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA,oCAAoC;AACpC;EACE,qDAAqD;EACrD;;;;;;;;;6CAS2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB;;;uCAGqC;EACrC,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,yDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,2CAA2C;EAC3C;oCACkC;EAClC,kCAAkC;EAClC,wDAAwD;AAC1D;;AAEA,+BAA+B;AAC/B;EACE,iDAAiD;EACjD,yDAAmD;EACnD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,2CAA2C;EAC3C;oCACkC;EAClC,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,qDAAqD;EACrD;;;;;;;;;6CAS2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB;;;uCAGqC;EACrC,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,qDAAqD;EACrD;;;;;;;;;6CAS2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB;;;uCAGqC;EACrC,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,2CAA2C;AAC1D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,4DAA4D;EAC5D,cAAc;EACd,gBAAgB;EAChB,cAAc,EAAE,8CAA8C;EAC9D,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gEAAgE;EAChE;;;gCAG8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gEAAgE;EAChE;;;;;gCAK8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB;;;;;gCAK8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc,EAAE,8CAA8C;EAC9D,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,4DAA4D;AAC9D;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oDAAoD;IACpD,QAAQ;IACR,cAAc;IACd,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,SAAS;EACX;AACF","sourcesContent":["/* Reset and base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Accessibility utility classes */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Skip link for keyboard navigation */\n.skip-link {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background: #4a9c6d;\n  color: white;\n  padding: 8px 16px;\n  text-decoration: none;\n  z-index: 10000;\n  font-weight: bold;\n  border-radius: 0 0 4px 0;\n}\n\n.skip-link:focus {\n  top: 0;\n  outline: 3px solid #c9a227;\n  outline-offset: 2px;\n}\n\n/* Enhanced focus indicators */\n*:focus {\n  outline: 2px solid #4a9c6d;\n  outline-offset: 2px;\n}\n\n*:focus:not(:focus-visible) {\n  outline: none;\n}\n\n*:focus-visible {\n  outline: 2px solid #4a9c6d;\n  outline-offset: 2px;\n}\n\nbutton:focus-visible,\na:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n  outline: 2px solid #4a9c6d;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 4px rgba(74, 156, 109, 0.2);\n}\n\nbody {\n  font-family: 'Instrument Sans', 'Helvetica Neue', -apple-system, BlinkMacSystemFont, sans-serif;\n  background-color: #1a1a1a;\n  background-image:\n    repeating-linear-gradient(\n      0deg,\n      transparent,\n      transparent 2px,\n      rgba(0, 0, 0, 0.1) 2px,\n      rgba(0, 0, 0, 0.1) 4px\n    );\n  color: #e8e4dc;\n  line-height: 1.5;\n}\n\n/* App container */\n.app-container {\n  min-height: 100vh;\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Landing page: full-width flexbox layout with footer at bottom */\n.app-container--landing {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  padding: 0;\n  background: #111;\n  background-image: none;\n}\n\n.app-container--landing .main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.app-container--landing .landing-page {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 0;\n  max-width: 100%;\n  gap: 0;\n}\n\n/* Header - Pro Audio Rack Style */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  background: linear-gradient(180deg, #2d2d2d 0%, #242424 100%);\n  border-radius: 4px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.05),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.3),\n    0 2px 8px rgba(0, 0, 0, 0.4);\n  border: 1px solid #3a3a3a;\n  position: relative;\n  z-index: 1100;\n}\n\n.header::before {\n  content: '';\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  right: 4px;\n  height: 2px;\n  background: linear-gradient(90deg, transparent, rgba(212, 165, 116, 0.3), transparent);\n  border-radius: 1px;\n}\n\n.app-title {\n  font-family: 'Instrument Sans', 'DIN Alternate', 'Helvetica Neue', sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: #d4a227; /* Enhanced from #c9a227 for better contrast */\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* Buttons - Pro Audio Style */\n.btn {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  padding: 10px 18px;\n  border: 1px solid #4a4a4a;\n  border-radius: 3px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 80px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.btn-primary {\n  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);\n  color: #fff;\n  border-color: #3d8259;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.15),\n    0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.btn-primary:hover {\n  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.2),\n    0 3px 6px rgba(0, 0, 0, 0.4);\n  transform: none;\n}\n\n.btn-secondary {\n  background: linear-gradient(180deg, #3a3a3a 0%, #2d2d2d 100%);\n  color: #e8e4dc;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.05),\n    0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.btn-secondary:hover {\n  background: linear-gradient(180deg, #4a4a4a 0%, #3a3a3a 100%);\n  border-color: #5a5a5a;\n  transform: none;\n}\n\n/* Hidden controls - keep functionality but hide visually */\n.hidden-controls {\n  position: absolute;\n  left: -9999px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Main content */\n.main-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Landing page – SEO-friendly semantic layout */\n.landing-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 720px;\n  margin: 0 auto;\n  padding: 24px 20px 48px;\n  gap: 0;\n  margin: 0;\n}\n\n/* ===== Landing Waveform Banner ===== */\n.landing-hero-waveform {\n  position: relative;\n  width: 100vw;\n  margin-left: calc(-50vw + 50%);\n  height: 200px;\n  background: #000 url('./assets/hero-waveform.png') repeat-x center center;\n  background-size: auto 100%;\n}\n\n/* ===== Landing Gradient Body ===== */\n.landing-gradient-body {\n  background: linear-gradient(180deg,\n    #000000 0%,\n    #0a0d0a 15%,\n    #0d120e 30%,\n    #101510 50%,\n    #121812 70%,\n    #141a14 100%\n  );\n  flex: 1;\n}\n\n/* ===== Landing Hero Content ===== */\n.landing-hero-content {\n  text-align: center;\n  padding: 12px 24px 12px 24px;\n  width: 100%;\n}\n\n.landing-hero-title {\n  font-family: 'Instrument Sans', 'DIN Alternate', 'Helvetica Neue', sans-serif;\n  font-size: clamp(28px, 4vw, 40px);\n  font-weight: 700;\n  color: #e8e4dc;\n  letter-spacing: 0;\n  text-transform: none;\n  margin-bottom: 16px;\n  line-height: 1.25;\n  max-width: 680px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.landing-hero-tagline {\n  font-size: 16px;\n  color: #999;\n  line-height: 1.6;\n  margin-bottom: 36px;\n  max-width: 560px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.landing-cta-btn {\n  display: inline-block;\n  padding: 14px 36px;\n  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);\n  color: #fff;\n  border-radius: 30px;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  border: 1px solid #3d8259;\n  box-shadow: 0 2px 8px rgba(74, 156, 109, 0.2);\n}\n\n.landing-cta-btn:hover {\n  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);\n  box-shadow: 0 4px 20px rgba(74, 156, 109, 0.35);\n  transform: translateY(-1px);\n}\n\n/* ===== Landing Features Section ===== */\n.landing-features-section {\n  padding: 48px 48px 80px;\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n  background: transparent;\n}\n\n.landing-features-heading {\n  text-align: center;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: #e8e4dc;\n  margin-bottom: 12px;\n}\n\n.landing-features-subhead {\n  text-align: center;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 15px;\n  color: #888;\n  margin: 0 0 40px;\n}\n\n.landing-features-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 28px;\n}\n\n.landing-feature-card {\n  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);\n  border-radius: 12px;\n  border: 1px solid #2a2a2a;\n  padding: 20px;\n  transition: border-color 0.2s ease;\n}\n\n.landing-feature-card:hover {\n  border-color: #3a3a3a;\n}\n\n.landing-feature-card-img-wrapper {\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 20px;\n  background: #0a0a0a;\n  \n}\n\n.landing-feature-card-img-center {\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background-color: #282828;\n  border-radius: 6px;\n}\n\n.landing-feature-card-img {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 6px;\n}\n\n.landing-feature-card-title {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 17px;\n  font-weight: 700;\n  color: #e8e4dc;\n  margin-bottom: 8px;\n}\n\n.landing-feature-card-desc {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 14px;\n  color: #888;\n  line-height: 1.55;\n}\n\n.landing-feature-card-link {\n  display: inline-block;\n  margin-top: 16px;\n  color: #4a9c6d;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.landing-feature-card-link:hover {\n  color: #5aac7d;\n  text-decoration: underline;\n}\n\n.landing-feature-card-link:focus-visible {\n  outline: 2px solid #5aac7d;\n  outline-offset: 3px;\n}\n\n.landing-plans-section {\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 0 48px 80px;\n  text-align: center;\n}\n\n.landing-plans-section .plan-comparison {\n  margin-bottom: 24px;\n}\n\n.landing-plans-cta {\n  display: inline-block;\n  padding: 14px 36px;\n  border: 1px solid #3d8259;\n  border-radius: 30px;\n  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);\n  box-shadow: 0 2px 8px rgba(74, 156, 109, 0.2);\n  color: #fff;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: all 0.2s ease;\n}\n\n.landing-plans-cta:hover {\n  background: linear-gradient(180deg, #5aac7d 0%, #4a9269 100%);\n  box-shadow: 0 4px 20px rgba(74, 156, 109, 0.35);\n  transform: translateY(-1px);\n}\n\n/* Legacy landing classes (kept for non-landing usage) */\n.landing-body {\n  color: #c4bfb5;\n  line-height: 1.6;\n  margin-bottom: 15px;\n}\n\n/* ===== Landing page responsive ===== */\n@media (max-width: 1024px) {\n  .landing-features-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .landing-hero-waveform {\n    height: 120px;\n  }\n\n  .landing-hero-content {\n    padding: 24px 20px 16px;\n  }\n\n  .landing-hero-title {\n    font-size: clamp(22px, 6vw, 28px);\n    margin-bottom: 12px;\n  }\n\n  .landing-hero-tagline {\n    font-size: 15px;\n    margin-bottom: 28px;\n  }\n\n  .landing-cta-btn {\n    padding: 14px 32px;\n    font-size: 13px;\n  }\n\n  .landing-features-section {\n    padding: 32px 20px 48px;\n  }\n\n  .landing-plans-section {\n    padding: 0 20px 48px;\n  }\n\n  .landing-features-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .landing-features-heading {\n    font-size: 20px;\n    margin-bottom: 24px;\n  }\n\n  .landing-feature-card-img-center {\n    height: 220px;\n  }\n}\n\n@media (max-width: 480px) {\n  .landing-hero-waveform {\n    height: 80px;\n  }\n\n  .landing-hero-content {\n    padding: 20px 16px 16px;\n  }\n\n  .landing-hero-title {\n    font-size: clamp(20px, 5.5vw, 24px);\n  }\n\n  .landing-hero-tagline {\n    font-size: 14px;\n    line-height: 1.5;\n    margin-bottom: 24px;\n  }\n\n  .landing-hero-tagline br {\n    display: none;\n  }\n\n  .landing-cta-btn {\n    padding: 14px 28px;\n    font-size: 12px;\n    width: 100%;\n    max-width: 280px;\n    text-align: center;\n  }\n\n  .landing-features-section {\n    padding: 24px 16px 40px;\n  }\n\n  .landing-plans-section {\n    padding: 0 16px 40px;\n  }\n\n  .landing-features-heading {\n    font-size: 18px;\n    margin-bottom: 20px;\n  }\n\n  .landing-feature-card {\n    padding: 16px;\n  }\n\n  .landing-feature-card-img-center {\n    height: 180px;\n  }\n\n  .landing-feature-card-title {\n    font-size: 16px;\n  }\n\n  .landing-feature-card-desc {\n    font-size: 13px;\n  }\n}\n\n/* ===== About page ===== */\n.about-section {\n  padding: 48px 48px 80px;\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.about-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 28px;\n}\n\n.about-card {\n  padding: 28px;\n}\n\n.about-card-title {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #e8e4dc;\n  margin-bottom: 12px;\n}\n\n.about-card-desc {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 15px;\n  color: #999;\n  line-height: 1.65;\n}\n\n.about-card-desc strong {\n  color: #e8e4dc;\n  font-weight: 600;\n}\n\n.about-card-list {\n  list-style: none;\n  padding: 0;\n  margin: 8px 0 0;\n}\n\n.about-card-list li {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 15px;\n  color: #999;\n  line-height: 1.65;\n  padding: 4px 0 4px 20px;\n  position: relative;\n}\n\n.about-card-list li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 12px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: linear-gradient(180deg, #4a9c6d 0%, #3d8259 100%);\n}\n\n.about-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 24px;\n  margin-top: 16px;\n}\n\n.about-contact {\n  text-align: center;\n  padding: 60px 24px 0;\n}\n\n.about-contact-text {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 16px;\n  color: #999;\n  margin-bottom: 28px;\n  line-height: 1.6;\n}\n\n/* ===== About page responsive ===== */\n@media (max-width: 768px) {\n  .about-section {\n    padding: 32px 20px 48px;\n  }\n\n  .about-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .about-card {\n    padding: 24px;\n  }\n\n  .about-card-title {\n    font-size: 17px;\n  }\n\n  .about-card-desc,\n  .about-card-list li {\n    font-size: 14px;\n  }\n\n  .about-contact {\n    padding: 40px 20px 0;\n  }\n\n  .about-contact-text {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-section {\n    padding: 24px 16px 40px;\n  }\n\n  .about-card {\n    padding: 20px;\n  }\n\n  .about-card-title {\n    font-size: 16px;\n  }\n\n  .about-card-desc,\n  .about-card-list li {\n    font-size: 13px;\n  }\n\n  .about-contact {\n    padding: 32px 16px 0;\n  }\n\n  .about-contact-text {\n    font-size: 14px;\n  }\n}\n\n/* ===== Newsletter page ===== */\n.newsletter-section {\n  padding: 48px 48px 80px;\n  width: 100%;\n  max-width: 580px;\n  margin: 0 auto;\n}\n\n.newsletter-card {\n  padding: 36px;\n}\n\n/* ===== Newsletter page responsive ===== */\n@media (max-width: 768px) {\n  .newsletter-section {\n    padding: 32px 20px 48px;\n  }\n\n  .newsletter-card {\n    padding: 28px;\n  }\n}\n\n@media (max-width: 480px) {\n  .newsletter-section {\n    padding: 24px 16px 40px;\n  }\n\n  .newsletter-card {\n    padding: 24px;\n  }\n}\n\n/* ===== Legal pages (Privacy Policy, Terms, Cookie Policy, Data Deletion) ===== */\n.legal-content-section {\n  padding: 48px 48px 80px;\n  width: 100%;\n  max-width: 860px;\n  margin: 0 auto;\n}\n\n.legal-content-card {\n  background: linear-gradient(180deg, #1a1a1a 0%, #151515 100%);\n  border-radius: 12px;\n  border: 1px solid #2a2a2a;\n  padding: 48px 56px;\n}\n\n.legal-content-card h2 {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #d4a574;\n  margin-top: 40px;\n  margin-bottom: 16px;\n  letter-spacing: 0.5px;\n}\n\n.legal-content-card h2:first-child {\n  margin-top: 0;\n}\n\n.legal-content-card h3 {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: #d4a574;\n  margin-top: 28px;\n  margin-bottom: 12px;\n  letter-spacing: 0.5px;\n}\n\n.legal-content-card p {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 15px;\n  color: #c4bfb5;\n  line-height: 1.7;\n  margin-bottom: 16px;\n}\n\n.legal-content-card ul {\n  list-style: none;\n  padding: 0;\n  margin: 16px 0;\n}\n\n.legal-content-card li {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 15px;\n  color: #c4bfb5;\n  line-height: 1.7;\n  padding: 4px 0 4px 24px;\n  position: relative;\n}\n\n.legal-content-card li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 13px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #666;\n}\n\n.legal-content-card a {\n  color: #4a9c6d;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.legal-content-card a:hover {\n  color: #5aac7d;\n  text-decoration: underline;\n}\n\n.legal-content-card code {\n  background: #0a0a0a;\n  padding: 2px 8px;\n  border-radius: 3px;\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-size: 13px;\n  color: #d4a574;\n  border: 1px solid #2a2a2a;\n}\n\n.legal-content-card strong {\n  font-weight: 600;\n  color: #e8e4dc;\n}\n\n.legal-last-updated {\n  font-style: italic;\n  color: #888;\n  font-size: 15px;\n}\n\n/* ===== Legal pages responsive ===== */\n@media (max-width: 768px) {\n  .legal-content-section {\n    padding: 32px 20px 48px;\n  }\n\n  .legal-content-card {\n    padding: 32px 28px;\n  }\n\n  .legal-content-card h2 {\n    font-size: 20px;\n    margin-top: 32px;\n  }\n\n  .legal-content-card h3 {\n    font-size: 17px;\n    margin-top: 24px;\n  }\n\n  .legal-content-card p,\n  .legal-content-card li {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .legal-content-section {\n    padding: 24px 16px 40px;\n  }\n\n  .legal-content-card {\n    padding: 24px 20px;\n  }\n\n  .legal-content-card h2 {\n    font-size: 18px;\n    margin-top: 28px;\n  }\n\n  .legal-content-card h3 {\n    font-size: 16px;\n    margin-top: 20px;\n  }\n\n  .legal-content-card p,\n  .legal-content-card li {\n    font-size: 13px;\n  }\n\n  .legal-last-updated {\n    font-size: 14px;\n  }\n}\n\n/* Top row layout */\n.top-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 20px;\n  height: 400px;\n}\n\n/* Right panel */\n.right-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Cards - Pro Audio Style */\n.card {\n  background: linear-gradient(180deg, #2a2a2a 0%, #222222 100%);\n  border-radius: 4px;\n  padding: 20px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.04),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.2),\n    0 4px 16px rgba(0, 0, 0, 0.4);\n  border: 1px solid #3a3a3a;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 20px;\n  right: 20px;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(212, 165, 116, 0.2), transparent);\n}\n\n.card-title {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  color: #d4a227; /* Enhanced from #c9a227 for better contrast */\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n}\n\n/* EQ Card Header */\n.eq-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.eq-card-header .card-title {\n  margin-bottom: 0;\n}\n\n.eq-controls {\n  display: flex;\n  gap: 12px;\n}\n\n.chart-container {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding-bottom: 8px;\n  background: #1a1a1a;\n  border-radius: 3px;\n  border: 1px solid #2a2a2a;\n}\n\n/* Specific card sizing */\n.frequency-response-card {\n  flex: 0.5;\n  min-height: 180px;\n}\n\n.spectrogram-card {\n  height: 100%;\n}\n\n.z-plane-card {\n  flex: 1;\n  min-height: 180px;\n}\n\n.eq-card {\n  height: 320px;\n}\n\n/* Canvas styling */\n#bar-graph {\n  background-color: #0a0a0a;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 280px;\n  border-radius: 3px;\n}\n\n#spectrogram {\n  background: #0a0a0a;\n  width: 100%;\n  height: 100%;\n  border-radius: 3px;\n}\n\n#z-plane {\n  background-color: #0f0f14;\n  border: 1px solid #2a2a2a;\n  border-radius: 3px;\n  width: 100%;\n  height: 100%;\n}\n\n/* EQ Container */\n#eq-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background: linear-gradient(180deg, #252525 0%, #1a1a1a 100%);\n  border-radius: 3px;\n  padding: 16px 12px;\n  box-shadow:\n    inset 0 2px 4px rgba(0, 0, 0, 0.4),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.02);\n  border: 1px solid #3a3a3a;\n}\n\n.eq-bottom-controls {\n  margin-top: 12px;\n  display: flex;\n  justify-content: flex-start;\n  padding-left: 10px;\n}\n\n.eq-locked-caption {\n  margin: 10px 10px 0;\n  color: #a09588;\n  font-size: 12px;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.eq-led-caption {\n  margin: 8px 10px 0;\n  color: #8a8578;\n  font-size: 11px;\n  line-height: 1.4;\n  text-align: center;\n}\n\n/* DBA hardware-style rocker toggle */\n.eq-tooltip-toggle {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0;\n  border: none;\n  background: none;\n  user-select: none;\n  cursor: pointer;\n}\n\n.eq-tooltip-toggle-text {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #706a60;\n}\n\n/* Rocker switch housing */\n.eq-tooltip-toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 14px;\n  height: 22px;\n  border-radius: 2px;\n  background: linear-gradient(180deg, #0a0a0a 0%, #151515 50%, #0a0a0a 100%);\n  border: 1px solid #2a2a2a;\n  box-shadow:\n    inset 0 0 3px rgba(0, 0, 0, 0.9),\n    0 1px 0 rgba(255, 255, 255, 0.03);\n  pointer-events: none;\n}\n\n/* Rocker switch actuator - off state (tilted up) */\n.eq-tooltip-toggle-switch::before {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  right: 2px;\n  height: 8px;\n  border-radius: 1px;\n  background: linear-gradient(180deg, #8a847a 0%, #5a554c 50%, #3a3632 100%);\n  box-shadow:\n    0 1px 2px rgba(0, 0, 0, 0.5),\n    inset 0 1px 0 rgba(255, 255, 255, 0.15);\n  transition: top 0.08s ease, transform 0.08s ease, background 0.08s ease;\n  transform-origin: center bottom;\n  transform: perspective(20px) rotateX(8deg);\n}\n\n/* On state - rocker tilted down */\n.eq-tooltip-toggle-switch.active::before {\n  top: 10px;\n  transform: perspective(20px) rotateX(-8deg);\n  background: linear-gradient(180deg, #a09a90 0%, #706a60 50%, #4a4640 100%);\n}\n\n.eq-tooltip-toggle:hover .eq-tooltip-toggle-switch {\n  border-color: #3a3a3a;\n}\n\n.eq-tooltip-toggle:hover .eq-tooltip-toggle-switch::before {\n  background: linear-gradient(180deg, #9a948a 0%, #6a645a 50%, #4a4642 100%);\n}\n\n.eq-tooltip-toggle .toggle-hint {\n  position: static;\n  transform: none;\n  font-size: 11px;\n  padding: 2px 4px;\n  margin-left: 4px;\n}\n\n#eq-bands {\n  display: grid;\n  grid-template-columns: repeat(31, 1fr);\n  align-items: flex-end;\n  gap: 4px;\n  height: 200px;\n  padding: 0 10px;\n  overflow-x: auto;\n}\n\n.eq-band {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Slider Track */\n.eq-slider-track {\n  width: 12px;\n  height: 120px;\n  background: linear-gradient(\n    to right,\n    #2a2a2a 0%,\n    #333333 20%,\n    #2d2d2d 50%,\n    #333333 80%,\n    #2a2a2a 100%\n  );\n  border-radius: 3px;\n  position: relative;\n  box-shadow:\n    0 2px 4px rgba(0, 0, 0, 0.3),\n    inset 0 1px 1px rgba(0, 0, 0, 0.4),\n    inset 0 -1px 1px rgba(255, 255, 255, 0.05);\n  border: 1px solid #444;\n}\n\n/* Center groove in track */\n.eq-slider-track::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 2px;\n  bottom: 2px;\n  width: 3px;\n  transform: translateX(-50%);\n  background: linear-gradient(to bottom, #1a1a1a 0%, #111111 50%, #0a0a0a 100%);\n  border-radius: 1px;\n  box-shadow:\n    inset 0 1px 2px rgba(0, 0, 0, 0.9),\n    0 0 1px rgba(255, 255, 255, 0.1);\n}\n\n/* Keyboard shortcut hint */\n.keyboard-hint {\n  position: absolute;\n  top: -28px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.9);\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  font-family: monospace;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 100;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  animation: fadeInKeyboardHint 0.15s ease-out;\n}\n\n.keyboard-hint::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid rgba(0, 0, 0, 0.9);\n}\n\n@keyframes fadeInKeyboardHint {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* Slider Handle/Button */\n.eq-button {\n  width: 20px;\n  height: 28px;\n  border: none;\n  border-radius: 1px;\n  /* Photorealistic image with fallback */\n  background-image: url('./assets/slider-handle.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  /* Fallback styling if image fails to load */\n  background-color: #d0d0d0;\n  color: #333;\n  font-size: 8px;\n  font-weight: 700;\n  cursor: grab;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 46px; /* Center position */\n  left: 50%;\n  transform: translateX(-50%);\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.3);\n  z-index: 2;\n}\n\n/* Fallback styling when image is not available */\n.eq-button:not([style*=\"background-image\"]) {\n  background: linear-gradient(145deg, #f0f0f0, #d0d0d0);\n  border: 1px solid #555;\n  border-radius: 6px;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.4),\n    inset 0 1px 1px rgba(255, 255, 255, 0.8),\n    inset 0 -1px 1px rgba(0, 0, 0, 0.1);\n\n  /* Add ridged texture effect for fallback */\n  background-image:\n    repeating-linear-gradient(90deg,\n      transparent 0px,\n      transparent 1px,\n      rgba(0, 0, 0, 0.1) 1px,\n      rgba(0, 0, 0, 0.1) 2px,\n      transparent 2px,\n      transparent 3px\n    ),\n    linear-gradient(145deg, #f0f0f0, #d0d0d0);\n}\n\n.eq-button:hover {\n  /* Keep the photorealistic image */\n  background-image: url('./assets/slider-handle.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  transform: translateX(-50%) translateY(-1px);\n  box-shadow:\n    0 2px 4px rgba(0, 0, 0, 0.4);\n  /* Add a subtle brightness filter for hover effect */\n  filter: brightness(1.1) contrast(1.05);\n}\n\n/* Fallback hover styling */\n.eq-button:hover:not([style*=\"background-image\"]) {\n  background: linear-gradient(145deg, #f8f8f8, #d8d8d8);\n  background-image:\n    repeating-linear-gradient(90deg,\n      transparent 0px,\n      transparent 1px,\n      rgba(0, 0, 0, 0.1) 1px,\n      rgba(0, 0, 0, 0.1) 2px,\n      transparent 2px,\n      transparent 3px\n    ),\n    linear-gradient(145deg, #f8f8f8, #d8d8d8);\n  box-shadow:\n    0 2px 4px rgba(0, 0, 0, 0.4),\n    inset 0 1px 1px rgba(255, 255, 255, 0.9),\n    inset 0 -1px 1px rgba(0, 0, 0, 0.1);\n  filter: none;\n}\n\n.eq-button.active {\n  /* Use the photorealistic image with blue tint */\n  background-image: url('./assets/slider-handle.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: white;\n  cursor: grabbing;\n  box-shadow:\n    0 1px 3px rgba(0, 122, 255, 0.4);\n  /* Apply blue filter to the image */\n  filter: hue-rotate(200deg) saturate(1.5) brightness(0.9);\n}\n\n/* Fallback active styling */\n.eq-button.active:not([style*=\"background-image\"]) {\n  background: linear-gradient(145deg, #007aff, #0056cc);\n  background-image:\n    repeating-linear-gradient(90deg,\n      transparent 0px,\n      transparent 1px,\n      rgba(255, 255, 255, 0.1) 1px,\n      rgba(255, 255, 255, 0.1) 2px,\n      transparent 2px,\n      transparent 3px\n    ),\n    linear-gradient(145deg, #007aff, #0056cc);\n  border: 1px solid #004499;\n  border-radius: 6px;\n  box-shadow:\n    0 1px 3px rgba(0, 122, 255, 0.4),\n    inset 0 1px 1px rgba(255, 255, 255, 0.3),\n    inset 0 -1px 1px rgba(0, 0, 0, 0.2);\n  filter: none;\n}\n\n.eq-button.nearest-target {\n  /* Use the photorealistic image with orange tint */\n  background-image: url('./assets/slider-handle.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: white;\n  animation: pulse-target 1.5s ease-in-out infinite;\n  box-shadow:\n    0 1px 3px rgba(255, 149, 0, 0.4);\n  /* Apply orange filter to the image */\n  filter: hue-rotate(30deg) saturate(1.8) brightness(1.1);\n}\n\n/* Fallback nearest-target styling */\n.eq-button.nearest-target:not([style*=\"background-image\"]) {\n  background: linear-gradient(145deg, #ff9500, #cc7700);\n  background-image:\n    repeating-linear-gradient(90deg,\n      transparent 0px,\n      transparent 1px,\n      rgba(255, 255, 255, 0.15) 1px,\n      rgba(255, 255, 255, 0.15) 2px,\n      transparent 2px,\n      transparent 3px\n    ),\n    linear-gradient(145deg, #ff9500, #cc7700);\n  border: 1px solid #aa6600;\n  border-radius: 6px;\n  box-shadow:\n    0 1px 3px rgba(255, 149, 0, 0.4),\n    inset 0 1px 1px rgba(255, 255, 255, 0.3),\n    inset 0 -1px 1px rgba(0, 0, 0, 0.2);\n  filter: none;\n}\n\n.eq-button.incorrect {\n  /* Use the photorealistic image with red tint */\n  background-image: url('./assets/slider-handle.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: white;\n  animation: shake-incorrect 0.3s ease-in-out;\n  box-shadow:\n    0 1px 3px rgba(255, 59, 48, 0.4);\n  /* Apply red filter to the image */\n  filter: hue-rotate(340deg) saturate(1.6) brightness(0.8);\n}\n\n/* Fallback incorrect styling */\n.eq-button.correct {\n  /* Use the photorealistic image with green tint */\n  background-image: url('./assets/slider-handle.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: white;\n  animation: shake-incorrect 0.3s ease-in-out;\n  box-shadow:\n    0 1px 3px rgba(40, 167, 69, 0.4);\n  /* Apply green filter to the image */\n  filter: hue-rotate(90deg) saturate(1.6) brightness(0.6);\n}\n\n.eq-button.incorrect:not([style*=\"background-image\"]) {\n  background: linear-gradient(145deg, #ff3b30, #cc2e26);\n  background-image:\n    repeating-linear-gradient(90deg,\n      transparent 0px,\n      transparent 1px,\n      rgba(255, 255, 255, 0.15) 1px,\n      rgba(255, 255, 255, 0.15) 2px,\n      transparent 2px,\n      transparent 3px\n    ),\n    linear-gradient(145deg, #ff3b30, #cc2e26);\n  border: 1px solid #aa251d;\n  border-radius: 6px;\n  box-shadow:\n    0 1px 3px rgba(255, 59, 48, 0.4),\n    inset 0 1px 1px rgba(255, 255, 255, 0.3),\n    inset 0 -1px 1px rgba(0, 0, 0, 0.2);\n  filter: none;\n}\n\n/* Fallback correct styling */\n.eq-button.correct:not([style*=\"background-image\"]) {\n  background: linear-gradient(145deg, #28a745, #1e7e34);\n  background-image:\n    repeating-linear-gradient(90deg,\n      transparent 0px,\n      transparent 1px,\n      rgba(255, 255, 255, 0.15) 1px,\n      rgba(255, 255, 255, 0.15) 2px,\n      transparent 2px,\n      transparent 3px\n    ),\n    linear-gradient(145deg, #28a745, #1e7e34);\n  border: 1px solid #1e7e34;\n  border-radius: 6px;\n  box-shadow:\n    0 1px 3px rgba(40, 167, 69, 0.4),\n    inset 0 1px 1px rgba(255, 255, 255, 0.3),\n    inset 0 -1px 1px rgba(0, 0, 0, 0.2);\n  filter: none;\n}\n\n.eq-button.disabled,\n.eq-button:disabled {\n  cursor: not-allowed;\n  filter: grayscale(1) brightness(0.6);\n  opacity: 0.7;\n}\n\n.eq-label.disabled {\n  color: #888; /* Enhanced from #777 for better contrast */\n}\n\n.eq-led-checkbox:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n@keyframes pulse-target {\n  0%, 100% {\n    box-shadow: 0 4px 12px rgba(255, 149, 0, 0.3);\n  }\n  50% {\n    box-shadow: 0 4px 20px rgba(255, 149, 0, 0.6);\n  }\n}\n\n@keyframes shake-incorrect {\n  0%, 100% {\n    transform: translateX(-50%) translateY(0);\n  }\n  25% {\n    transform: translateX(-50%) translateY(-3px);\n  }\n  75% {\n    transform: translateX(-50%) translateY(3px);\n  }\n}\n\n.eq-label {\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 9px;\n  font-weight: 600;\n  color: #a09588; /* Enhanced from #8a8578 for better contrast */\n  text-align: center;\n  white-space: nowrap;\n  letter-spacing: 0.5px;\n}\n\n/* LED Checkbox styling */\n.eq-led-checkbox {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 1px solid #222;\n  background: radial-gradient(circle at 30% 30%, #4a4a4a, #2a2a2a);\n  box-shadow:\n    inset 0 1px 2px rgba(0, 0, 0, 0.8),\n    inset 0 -1px 1px rgba(255, 255, 255, 0.05),\n    0 1px 2px rgba(0, 0, 0, 0.5);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 4px;\n}\n\n.eq-led-checkbox:checked {\n  background: radial-gradient(circle at 30% 30%, #c9553d, #a84432);\n  box-shadow:\n    inset 0 1px 2px rgba(255, 255, 255, 0.2),\n    inset 0 -1px 1px rgba(0, 0, 0, 0.4),\n    0 0 8px rgba(201, 85, 61, 0.5),\n    0 0 12px rgba(201, 85, 61, 0.3),\n    0 1px 2px rgba(0, 0, 0, 0.6);\n  border-color: #c9553d;\n}\n\n.eq-led-checkbox:hover {\n  border-color: #444;\n}\n\n.eq-led-checkbox:checked:hover {\n  border-color: #d96550;\n  box-shadow:\n    inset 0 1px 2px rgba(255, 255, 255, 0.3),\n    inset 0 -1px 1px rgba(0, 0, 0, 0.3),\n    0 0 10px rgba(201, 85, 61, 0.7),\n    0 0 16px rgba(201, 85, 61, 0.4),\n    0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n/* Loading state */\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  padding: 40px;\n  text-align: center;\n  color: #a09588; /* Enhanced from #8a8578 for better contrast */\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n}\n\n.loading::before {\n  content: '';\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(212, 165, 116, 0.2);\n  border-top-color: #d4a574;\n  border-radius: 50%;\n  animation: loading-spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes loading-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Error state */\n.error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  padding: 40px;\n  text-align: center;\n  color: #c9553d;\n  background: linear-gradient(180deg, #2a2222 0%, #221a1a 100%);\n  border-radius: 4px;\n  border: 1px solid #4a3333;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Responsive design */\n@media (max-width: 1200px) {\n  .top-row {\n    grid-template-columns: 1fr;\n    height: auto;\n  }\n\n  .right-panel {\n    flex-direction: row;\n  }\n\n  .frequency-response-card {\n    height: 300px;\n  }\n}\n\n@media (max-width: 768px) {\n  .app-container {\n    padding: 16px;\n  }\n\n  .header {\n    padding: 14px 16px;\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n\n  .app-title {\n    font-size: 16px;\n    letter-spacing: 1.5px;\n  }\n\n  .controls {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .btn {\n    padding: 8px 14px;\n    font-size: 11px;\n  }\n\n  .right-panel {\n    flex-direction: column;\n  }\n\n  #eq-bands {\n    grid-template-columns: repeat(31, minmax(12px, 1fr));\n    gap: 2px;\n    padding: 0 8px;\n    height: 180px;\n  }\n\n  .eq-slider-track {\n    width: 10px;\n    height: 100px;\n  }\n\n  .keyboard-hint {\n    font-size: 10px;\n    padding: 3px 6px;\n    top: -24px;\n  }\n\n  .eq-button {\n    width: 18px;\n    height: 24px;\n    font-size: 8px;\n    top: 38px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
